//import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import {useracc, postApi, putApi/*, deleteApi*/, consoleLog} from '../../../utils/functions';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';


//import Login from '../../login';
//import Register from '../../register';
import BBCode from '../bbcode/bbcode';
//import Image from '../upload/image';
//import File from '../upload/file';
//import FilesGallery from '../upload/files-gallery';
//import Gallery from 'react-photo-gallery';
//import EmojiPicker from 'emoji-picker-react';
import Giphy from './giphy';
import GifPicker from 'gif-picker-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';
import moment from 'moment';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip';
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
//import Button from 'react-bootstrap/Button';

//import Palette from '../colour/palette';


import "./chatbox.css";
//import { Button } from 'react-bootstrap/lib/InputGroup';

//const fetchGifs = (number) => gf.search(searchTerm, { offset, limit: 10 });


class Chatbox extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			chatbox: {
				service: parseInt(props.service),
				category: props.category,
				type: props.type,
				premium: false,
				avatar: '',
				header: '',
				description: '',
				
			},
			chats: [],
			show: {
				footer: this.props.replay ? false : true,
				extras: false,
				reply: false,
				users: false,
				//emojis: false,
				mention: false,
			},
			message: '',
			ServiceChatbox: null,
    };

		this.postMessage = this.postMessage.bind(this);

		this.setPremium = this.setPremium.bind(this);
		this.setShow = this.setShow.bind(this);


  };

	async componentDidMount() {
		console.log(this.props);
		const value = this.context;
		const getUser = await useracc();
    value.setUser( getUser );
		const y = await value.setWorker( this.props.service );
		let server = value.worker[this.props.service] || y[this.props.service];

		//---- Get chat messages
		var params = new URLSearchParams();
		params.append('service', this.state.chatbox.service);
		params.append('category', this.state.chatbox.category);
		if( this.props.replay )
			params.append('replay', this.props.replay);
		params.append('header', true);
		const x = await postApi(`${server}/v3/service/chatbox`, params);
		consoleLog(x.data);
		if( x.status !== 200 ) return;

		let chatbox = this.state.chatbox;
		chatbox.title = `${x.data.header[0].title} Chats`;
		chatbox.avatar = x.data.header[0].avatar;
		this.setState({chatbox, chats: this.props.chats || x.data.chats});
		//console.log(this.props)

		//---- Connect Chatbox
    EventEmitter.emit(`/portal/chatbox/connect`, {service: this.state.chatbox.service});

		const ServiceChatbox = EventEmitter.addListener(`/service/chatbox`, async data => {
			if( data.service === this.state.chatbox.service && data.category === this.state.chatbox.category ) {
				this.setState({chats: data.chats});
			}
		}); this.setState({ServiceChatbox});
		
	}

	componentWillUnmount() {
		EventEmitter.emit(`/service/chatbox/disconnect`, {service: this.state.chatbox.service});
		if( this.state.ServiceChatbox ) this.state.ServiceChatbox.remove();
	}

	
	async postMessage(message) {
		document.body.click();
		consoleLog(message);
		const params = new URLSearchParams();
		
		params.append('service', this.state.chatbox.service);
		params.append('category', this.state.chatbox.category);
		if( message ) {
			if( message.length === 0 ) return;
			params.append('message', message);
		} else {
			if( this.state.message.length === 0 ) return;
			params.append('message', this.state.message);
		}

    //params.append('message', '[img]https://media.giphy.com/media/'+url+'/giphy.gif[/img]');
    await putApi(`${this.context.worker[this.state.chatbox.service]}/v3/service/chatbox`, params);
		//this.setState({showextras: false, customMention: false});
		this.setShow();

	}

	setPremium(premium) {
		let chatbox = this.state.chatbox;
		chatbox.premium = premium;
		this.setState({chatbox});
	}


	setShow(setting = null, value = null) {
		let show = this.state.show;
		if( !setting ) {
			for( let i in show ) {
				show[i] = false;
			}
		} else {
			show[setting] = value;
		}
		this.setState({show});
	}

	

	render() {
		//const user = this.context;

		let current_date = new Date();
		let current_uid = 0;
		let current_name = '';

		const chats = this.state.chats.map((e,i) => {
			//console.log(e);
			let _date = new Date(e.time);
			let change_date = false;
			let change_uid = false;
			if(_date.getDate() !== current_date.getDate()) {
				change_date = change_uid = true;
				current_date = _date;
			}
			if( e.uid !== current_uid || e.name !== current_name ) {
				change_uid = true;
				current_uid = e.uid;
				current_name = e.name;
			}
			switch( e.platform ) {
				case 'Mixcloud': case 'Twitch':
					e.avatar = `/images/platforms/${e.platform.toLowerCase()}.png`;
				break;
				default:
				break;
			}

			//---- Styling name
			let chatname = <span className="chatnameperson"><strong>{e.name}</strong></span>;
			if( Object.values(e.bot).length > 0 ) {
				//console.log(e.bot);
				switch(e.platform) {
					case 'Twitch':
						let badges = [];
						if( e.bot.badges )
							for( let j of Object.keys(e.bot.badges) ) {
								//console.log(j, e.bot.badges[j]);
								switch(j) {
									case 'broadcaster':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/5527c58c-fb7d-422d-b71b-f309dcb85cc1/1" alt="broadcaster" style={{marginRight: 2}} />)
									break;
									case 'moderator':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/3267646d-33f0-4b17-b3df-f923a41db1d0/1" alt="moderator" style={{marginRight: 2}} />)
									break;
									case 'founder':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/6894946b-3ccc-4329-84df-82306ee200ae/1" alt="founder" style={{marginRight: 2}} />)
									break;
									case 'subscriber':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/4b6f71e1-d564-42e6-af8d-ae0568fcb044/1" alt="subscriber" style={{marginRight: 2}} />)
									break;
									case 'subtember-2025':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/a9c01f28-179e-486d-a4c7-2277e4f6adb4/1" alt="twitch-dj" style={{marginRight: 2}} />)
									break;
									case 'twitch-dj':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/cf91bbc0-0332-413a-a7f3-e36bac08b624/1" alt="twitch-dj" style={{marginRight: 2}} />)
									break;
									case 'vip':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/b817aba4-fad8-49e2-b88a-7cc744dfa6ec/1" alt="vip" style={{marginRight: 2}} />)
									break;
									case 'bot-badge':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/3ffa9565-c35b-4cad-800b-041e60659cf2/1" alt="bot-badge" style={{marginRight: 2}} />)
									break;
									case 'bits':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/0d85a29e-79ad-4c63-a285-3acd2c66f2ba/1" alt="bot-badge" style={{marginRight: 2}} />)
									break;
									case 'premium':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/bbbe0db0-a598-423e-86d0-f9fb98ca1933/1" alt="premium" style={{marginRight: 2}} />)
									break;
									case 'partner':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/d12a2e27-16f6-41d0-ab77-b780518f00a3/1" alt="vip" style={{marginRight: 2}} />)
									break;
									case 'twitch-recap-2024':
										badges.push(<img src="https://static-cdn.jtvnw.net/badges/v1/72f2a6ac-3d9b-4406-b9e9-998b27182f61/1" alt="vip" style={{marginRight: 2}} />)
									break;
									default:
										//console.log(j);
										//badges.push(<>{j} {e.bot.badges[j]}</>);
									break;
								}
							}
						//console.log(badges);
						chatname = <span className="chatnameperson" style={{color: e.bot.color?e.bot.color:'#FF0000'}}>{badges.map((f)=>{return f})}<strong>{e.name} {}</strong></span>;
					break;
					default:
					break;
				}

				//if( e.bot.emotes ) console.log(e.bot.emotes, e.text);
			}

			return (
				<React.Fragment key={i}>
					{change_date === true &&
						<li className="chat-day-label">
							<span>
								{(_date.getDate() === new Date().getDate()) ?
									<>Today</>
								:
									<>{moment(_date).format("Do MMM")} {_date.getYear() !== new Date().getYear() && <>{moment(_date).format("YYYY")}</>}</>
								}
							</span>
						</li>
					}
					{((this.state.chatbox.premium === true && e.premium === 1) || this.state.chatbox.premium === false) &&
					<li key={i} className={`chat-item-start ${change_uid===true?'chat-item-start-header':''}`}>
						<div className="chat-list-inner">
							
							<div className="livestream-chatbox-profile">
								{change_uid === true ?
									<span className="avatar avatar-sm avatar-rounded chatstatusperson">
									
										<img className="livestream-chatbox-body-messages-avatar" src={`https://cloud.ultrastream.io${e.avatar}`} alt="img" />
									
									</span>
								:
									<div className="main-chat-spacer"></div>
								}
							</div>
							<div className="ms-2">
								{change_uid === true &&
									<span className="chatting-user-info">
										
										{chatname} <span className="msg-sent-time">{moment(e.time).format("HH:mm")}</span>
									</span>
								}
								<div className="main-chat-msg">
									<div>
										<BBCode text={e.text} />
									</div>
								</div>
							</div>
						</div>
					</li>
					}
				</React.Fragment>
			)
		});

		return (
			<>

      <div className="livestream-chatbox">
        <div className="livestream-chatbox-header">
          <div className="d-flex align-items-center p-2">
            <div className="me-2 lh-1">
              <span className="">
                <img src={this.state.chatbox.avatar?`https://cloud.ultrastream.io/images/${this.state.chatbox.avatar}?d=${Math.floor(Date.now()/1000)}`:`https://cloud.ultrastream.io/images/logo-us.png?d=${Math.floor(Date.now()/1000)}`} alt="img" width="200" />
              </span>
            </div>
            <div className="flex-fill">
              <div className="livestream-chatbox-header-title" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                {this.state.chatbox.title}
                {this.state.chatbox.category==='live'?
                  <p className="mb-0 chatpersonstatus">
                    <span style={{textDecoration: this.state.chatbox.premium===true?'underline':'none', cursor: 'pointer'}} onClick={()=>this.setPremium(true)}>TOP CHATS</span> - <span style={{textDecoration: this.state.chatbox.premium===true?'none':'underline', cursor: 'pointer'}} onClick={()=>this.setPremium(false)}>ALL CHATS</span>
                  </p>
                :
                  <p className="text-success mb-0 chatpersonstatus">online</p>
                }
              </div>
            </div>
            <div className="d-flex flex-wrap gap-1">
              {/*<button aria-label="button" type="button" className="btn btn-icon btn-light ms-2">
                <i className="bx bx-phone"></i>
              </button>
              <button aria-label="button" type="button" className="btn btn-icon btn-light ms-2">
                <i className="bx bx-video"></i>
              </button>*/}
              <button aria-label="button" type="button" className="btn btn-icon btn-light ms-2 responsive-userinfo-open" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
                <i className="bx bx-user-circle" id="responsive-chat-close"></i>
              </button>
              {/*<div className="dropdown ms-2">
                <button aria-label="button" type="button" className="btn btn-icon btn-light btn-wave waves-light waves-effect" data-bs-toggle="dropdown" aria-expanded="false">
                  <i className="ti ti-dots-vertical"></i>
                </button>
                <ul className="dropdown-menu" style={{}}>
                  <li><a className="dropdown-item" href="/">Profile</a></li>
                  <li><a className="dropdown-item" href="/">Clear Chat</a></li>
                  <li><a className="dropdown-item" href="/">Delete User</a></li>
                  <li><a className="dropdown-item" href="/">Block User</a></li>
                  <li><a className="dropdown-item" href="/">Report</a></li>
                </ul>
              </div>
              <button aria-label="button" type="button" className="btn btn-icon btn-outline-light ms-2 responsive-chat-close">
                <i className="ri-close-line"></i>
              </button>*/}
            </div>
          </div>
        </div>
        <div className={`livestream-chatbox-body ${this.state.show.footer === false?'livestream-chatbox-body-footer':''}`}>
          <div className="livestream-chatbox-body-messages">
            <ul className="list-unstyled">
              {chats}
            </ul>
          </div>
        </div>
				{this.state.show.footer === true &&
					<div className="livestream-chatbox-footer">
						
						{this.state.show.extras === true?
							<>
								<OverlayTrigger placement="bottom" trigger="hover" key="overlay-1" overlay={<Tooltip id="tooltip1">Insert Giphy</Tooltip>}>
									<label>
										<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
											<Popover id="popover-basic" popover-positioned="top" className="popover-giphy bg-dark">
												<div className="dropdown-content-giphy">
													<Giphy selectUrl={result=>{this.postMessage(`[img]https://media.giphy.com/media/${result}/giphy.gif[/img]`)}} />
												</div>
											</Popover>
											}>
											<div aria-label="anchor" className="btn btn-sm me-2 btn-light"><FontAwesomeIcon icon="image" style={{color: '#1E90FF'}} /></div>
										</OverlayTrigger>
									</label>
								</OverlayTrigger>
								<OverlayTrigger placement="bottom" trigger="hover" key="overlay-2" overlay={<Tooltip id="tooltip1">Insert Tenor</Tooltip>}>
									<label>
										<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
											<Popover id="popover-basic" popover-positioned="top" className="popover-giphy bg-dark">
												<GifPicker tenorApiKey={"AIzaSyALVVXstIng9XHNe2B8O-zY4e2hZtJChOg"} onGifClick={result=>this.postMessage(`[img]${result.url}[/img]`)} width='100%' theme="dark" autoFocusSearch={false} />
											</Popover>
											}>
											<div aria-label="anchor" className="btn btn-sm me-2 btn-light"><FontAwesomeIcon icon="images" style={{color: '#228B22'}} /></div>
										</OverlayTrigger>
									</label>
								</OverlayTrigger>
								<OverlayTrigger placement="bottom" trigger="hover" key="overlay-3" overlay={<Tooltip id="tooltip1">Mention member</Tooltip>}>
									<label>
										<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
											<Popover id="popover-basic" popover-positioned="top" className="popover-mention bg-dark">
												<div className="dropdown-content-mention">
													{/*online*/}
												</div>
											</Popover>
											}>
											<div aria-label="anchor" className="btn btn-sm me-2 btn-light"><FontAwesomeIcon icon="user" style={{color: '#FF1493'}} /></div>
										</OverlayTrigger>
									</label>
								</OverlayTrigger>
								<OverlayTrigger placement="bottom" trigger="hover" key="overlay-4" overlay={<Tooltip id="tooltip1">{this.state.chatbox==='technical'?'Upload File':'Upload Image'}</Tooltip>}>
									<label>
										<OverlayTrigger trigger="click" placement="top" rootClose="true" overlay={
											<Popover id="popover-basic" popover-positioned="top" className="popover-image bg-dark">
												<div className="dropdown-content-image bg-dark">
													<div className="dropdown-content-inner">
														<div className="dropdown-content-header">
															{/*this.state.chatbox==='technical'?
																<>
																	<File channel={this.state.chatbox} complete={()=>{this.showExtras();}} />
																	<FilesGallery files={this.state.files} submit={event=>this.File(event)} />
																</>
															:
																<Image channel={this.state.chatbox} complete={()=>{this.showExtras();}} />
															*/}
														</div>
														<div className="dropdown-content-body">
															{/*Object.keys(this.state.gallery).length === 0 ?
																<Gallery photos={this.state.gallery} renderImage={this.renderImage} />
															:
																<Gallery photos={this.state.gallery} direction={"column"} columns={4} renderImage={this.renderImage} />
															*/}
														</div>
													</div>
												</div>
											</Popover>
											}>
											<div aria-label="anchor" className="btn btn-sm me-2 btn-light"><FontAwesomeIcon icon="cloud-arrow-up" style={{color: '#FF8C00'}} /></div>
										</OverlayTrigger>
									</label>
								</OverlayTrigger>
							</>
						:
							<>
								<div aria-label="anchor" className="btn btn-sm mx-1 btn-light" onClick={()=>this.setShow('extras', true)}>
									<FontAwesomeIcon className="" icon="circle-plus" size="lg" style={{color: '#1E90FF'}} />
								</div>
							</>
						}
						<textarea rows="1" id="textarea" className="form-control form-control-sm me-1" placeholder="Type your message here..." type="text" onClick={()=>this.setShow('extras', false)}
							value={this.state.message}
							onChange={e=>{
								this.setState({message: e.target.value.substring(0,400)});
							}}
							onKeyDown={(e)=>{
								if( e.shiftKey && e.code==="Quote" ) {
									//this.setState({customMention: e.target.selectionStart+1});
								}
								if( e.keyCode === 13 && !e.shiftKey ) {
									e.preventDefault();
									e.stopPropagation();
									this.postMessage();
								}
								
								/*this.handleSubmit(e);
								if( this.state.customMention !== false ) {
									this.customMention(e);
									if( e.keyCode === 32 ) this.setState({customMention: false});
								}*/
							}}
							onKeyUp={(e)=>{
								if( ( e.which || e.keycode ) === 229 ) {
									let ss = e.target.selectionStart-1 || 0;
									if( e.target.textContent.substr(ss,1) === '@' ) {
										/*this.setState({customMention: e.target.selectionStart},()=>{
											this.customMention(e);
										});*/
									}
									if( e.target.textContent.substr(ss,1) === ' ' ) {
										//this.setState({customMention: false});
									}
								}
							}} style={{paddingRight:30}}

						/>
						

						
								<div aria-label="anchor" className="btn btn-sm me-1 btn-light" onClick={()=>this.postMessage()}>
									<FontAwesomeIcon className="" icon="circle-right" size="lg" style={{color: '#0d6efd'}} />
								</div>
							

					</div>
				}
      </div>
			
			{/*<div className="h-100">
				<div className="main-chart-wrapper pt-0 px-2 gap-2 d-lg-flex" >
					<div className="main-chat-area border">
						<div className="d-flex align-items-center p-2 border-bottom">
							<div className="me-2 lh-1">
								<span className="avatar avatar-lg online me-2 avatar-rounded chatstatusperson">
                  <img className="chatimageperson" src={this.state.chatbox.avatar?`https://cloud.ultrastream.io/images/${this.state.chatbox.avatar}`:"https://laravelui.spruko.com/velvet/build/assets/images/faces/2.jpg"} alt="img" width="200" />
								</span>
							</div>
							<div className="flex-fill">
								<div className="chatnameperson responsive-userinfo-open" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
									{this.state.chatbox.title}
									{this.state.chatbox.category==='live'?
										<p className="mb-0 chatpersonstatus">
											<span style={{textDecoration: this.state.chatbox.premium===true?'underline':'none', cursor: 'pointer'}} onClick={()=>this.setPremium(true)}>TOP CHATS</span> - <span style={{textDecoration: this.state.chatbox.premium===true?'none':'underline', cursor: 'pointer'}} onClick={()=>this.setPremium(false)}>ALL CHATS</span>
										</p>
									:
										<p className="text-success mb-0 chatpersonstatus">online</p>
									}
								</div>
							</div>
							<div className="d-flex flex-wrap gap-1">
								<button aria-label="button" type="button" className="btn btn-icon btn-light ms-2">
									<i className="bx bx-phone"></i>
								</button>
								<button aria-label="button" type="button" className="btn btn-icon btn-light ms-2">
									<i className="bx bx-video"></i>
								</button>
								<button aria-label="button" type="button" className="btn btn-icon btn-light ms-2 responsive-userinfo-open" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">
									<i className="bx bx-user-circle" id="responsive-chat-close"></i>
								</button>
								<div className="dropdown ms-2">
									<button aria-label="button" type="button" className="btn btn-icon btn-light btn-wave waves-light waves-effect" data-bs-toggle="dropdown" aria-expanded="false">
										<i className="ti ti-dots-vertical"></i>
									</button>
									<ul className="dropdown-menu" style={{}}>
										<li><a className="dropdown-item" href="/">Profile</a></li>
										<li><a className="dropdown-item" href="/">Clear Chat</a></li>
										<li><a className="dropdown-item" href="/">Delete User</a></li>
										<li><a className="dropdown-item" href="/">Block User</a></li>
										<li><a className="dropdown-item" href="/">Report</a></li>
									</ul>
								</div>
								<button aria-label="button" type="button" className="btn btn-icon btn-outline-light ms-2 responsive-chat-close">
									<i className="ri-close-line"></i>
								</button>
							</div>
						</div>
						<div className="content" id="main-chat-content" data-simplebar="init">
							<div className="simplebar-wrapper" style={{margin: -20}}>
							<div className="simplebar-height-auto-observer-wrapper">
								<div className="simplebar-height-auto-observer">
									</div>
								</div>
								<div className="simplebar-mask">
									<div className="simplebar-offset" style={{right: 0, bottom: 0}}>
										<div className="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content" style={{height: 'auto', overflow: 'hidden scroll'}}>
											<div className="simplebar-content" style={{padding: 20}}>
												<ul className="list-unstyled">
													{chats}
												</ul>
											</div>
										</div>
									</div>
								</div>
								<div className="simplebar-placeholder" style={{width: 'auto', height: '100%'}}>
								</div>
								</div>
								<div className="simplebar-track simplebar-horizontal" style={{visibility: 'hidden'}}>
									<div className="simplebar-scrollbar" style={{width: 0, display: 'none'}}>
									</div>
								</div>
								<div className="simplebar-track simplebar-vertical" style={{visibility: 'visible'}}>
									<div className="simplebar-scrollbar" style={{height: 'auto', transform: 'translate3d(0px, 163px, 0px)', display: 'block'}}>
									</div>
								</div>
							</div>
							<div className="chat-footer">
								
							</div>
						</div>
					</div>
				{/*</div>*/}
			</>
		);
	}
}

export default Chatbox;